const APP_NAME = 'sKRAMble';
const LOCAL_STORAGE_USER = 'LOCAL_STORAGE_USER';
const LOCAL_STORAGE_EVENT = 'LOCAL_STORAGE_EVENT';
const LOCAL_STORAGE_PAYMENT = 'LOCAL_STORAGE_PAYMENT';

// Bump this value to force all users to re-authenticate (e.g. between yearly events)
const AUTH_VERSION = '2026';
const LOCAL_STORAGE_AUTH_VERSION = 'AUTH_VERSION';

export {
    APP_NAME,
    LOCAL_STORAGE_USER,
    LOCAL_STORAGE_EVENT,
    LOCAL_STORAGE_PAYMENT,
    AUTH_VERSION,
    LOCAL_STORAGE_AUTH_VERSION
}